interface AppConfigType {
    BASE_URL: any;
    ISSSOENABLED: boolean;
    SHOW_VERSION_SELECTOR: boolean;
}

export const AppConfig: AppConfigType = {
    BASE_URL: process.env.REACT_APP_API_BASE_URL,
    ISSSOENABLED: true,
    SHOW_VERSION_SELECTOR: process.env.REACT_APP_SHOW_VERSION_SELECTOR === 'true'
};